// Libs
import React from "react";

// Context
import UrlSponsorContext from "contexts/UrlSponsor";

// Models
import UrlSponsorModel from "models/Sponsor/UrlSponsor";

export default class UrlSponsorProvider extends React.Component {
  state = {
    urlSponsor: {}
  };

  async componentDidMount() {
    const urlSponsor = await UrlSponsorModel.getSingle();
    this.setState({ urlSponsor });
  }

  render() {
    return (
      <UrlSponsorContext.Provider value={this.state.urlSponsor}>
        {this.props.children}
      </UrlSponsorContext.Provider>
    );
  }
}
